'use strict'
// import '@babel/polyfill'
import ServiceExec from '@/common/utils/ServiceExec'
import { forEach } from 'lodash'

/**
 * 회원공간 관련 API Service
 * @class SignSvc
 */
class ManagerSvc extends ServiceExec {
  /**
   *  교육목록 리스트
   *  @param limit {integer} 10
   *  @param page {integer} 1
   */
  getListBoxEdu(params = {}) {
    return this.get(`/api/home/manager/getListBoxEdu`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  교육목록 상세
   *  @param educationNo {integer} educationNo
   */
  getMapEdu(params = {}) {
    return this.get(`/api/home/manager/getMapEdu`, params).then(response => {
      return response.data
    })
  }

  /**
   *  교육신청 등록
   *  @param Authorization {string} Authorization
   *  @param eduApplyDTO {EduApplyDTO} eduApplyDTO
   */
  postIntEdu(params = {}) {
    return this.post(`/api/home/manager/postIntEdu`, params).then(response => {
      return response.data
    })
  }

  /**
   *  해당 회차 교육신청내역 확인
   *  @param Authorization {string} Authorization
   *  @param educationNo {integer} educationNo
   */
  getIntUserEduApply(params = {}) {
    return this.get(`/api/home/manager/getIntUserEduApply`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  교육신청 리스트
   *  @param Authorization {string} Authorization
   *  @param limit {integer} 10
   *  @param page {integer} 1
   *  @param statuses {ref} 신청상태(1: 접수, 2: 입금, 3:교육취소, 4:미수료, 5:수료)
   */
  getListBoxUserEdu(params = {}) {
    return this.get(`/api/home/manager/getListBoxUserEdu`, params).then(
      response => {
        return response.data
      }
    )
  }
  /**
   *  교육신청 상세
   *  @param userEducationNo {integer} userEducationNo
   */
  getMapUserEdu(params = {}) {
    return this.get(`/api/home/manager/getMapUserEdu`, params).then(
      response => {
        return response.data
      }
    )
  }
  /**
   *  교육신청 취소
   *  @param Authorization {string} Authorization
   *  @param account {ref} 계좌번호
   *  @param accountName {integer} 예금주명
   *  @param bank {integer} 은행명
   *  @param userEducationNo {integer} 교육신청 no
   */
  patchIntEduCancel(params = {}) {
    const formData = new FormData()
    forEach(params, function(value, key) {
      formData.append(key, value)
    })
    return this.patch(`/api/home/manager/patchIntEduCancel`, formData).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  시험목록 리스트
   *  @param limit {integer} 10
   *  @param page {integer} 1
   */
  getListBoxExam(params = {}) {
    return this.get(`/api/home/manager/getListBoxExam`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  시험목록 상세
   *  @param examinationNo {integer} examinationNo
   */
  getMapExam(params = {}) {
    return this.get(`/api/home/manager/getMapExam`, params).then(response => {
      return response.data
    })
  }

  /**
   *  해당 회차 시험신청내역 확인
   *  @param Authorization {string} Authorization
   *  @param examinationNo {integer} examinationNo
   */
  getIntUserExamApply(params = {}) {
    return this.get(`/api/home/manager/getIntUserExamApply`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  시험신청 등록
   *  @param Authorization {string} Authorization
   *  @param eduApplyDTO {ExamApplyDTO} eduApplyDTO
   */
  postIntExam(params = {}) {
    return this.post(`/api/home/manager/postIntExam`, params).then(response => {
      return response.data
    })
  }

  /**
   *  시험 - 공지사항 리스트
   *  @param limit {integer} 10
   *  @param page {integer} 1
   */
  getListBoxExamNotice(params = {}) {
    return this.get(`/api/home/manager/getListBoxExamNotice`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  시험 - 공지사항 상세
   *  @param noticeNo {integer} noticeNo
   */
  getMapExamNotice(params = {}) {
    return this.get(`/api/home/manager/getMapExamNotice`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  시험신청 리스트
   *  @param Authorization {string} Authorization
   *  @param examStatuses {ref} 신청상태(1: 접수, 2: 입금, 3: 교육취소)
   *  @param limit {integer} 10
   *  @param page {integer} 1
   */
  getListBoxUserExam(params = {}) {
    return this.get(`/api/home/manager/getListBoxUserExam`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  시험신청 상세
   *  @param userExaminationNo {integer} userExaminationNo
   */
  getMapUserExam(params = {}) {
    return this.get(`/api/home/manager/getMapUserExam`, params).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  시험신청 취소
   *  @param Authorization {string} Authorization
   *  @param account {ref} 계좌번호
   *  @param accountName {integer} 예금주명
   *  @param bank {integer} 은행명
   *  @param userExaminationNo {integer} 시험신청 no
   */
  patchIntExamCancel(params = {}) {
    const formData = new FormData()
    forEach(params, function(value, key) {
      formData.append(key, value)
    })
    return this.patch(`/api/home/manager/patchIntExamCancel`, formData).then(
      response => {
        return response.data
      }
    )
  }

  /**
   *  자격증 발급 리스트
   *  @param Authorization {string} Authorization
   */
  fetchUserCertList(params = {}) {
    console.log('params.::::::', params)
    return this
      .get(`/api/home/manager/fetchUserCertList`, params)
      .then(response => {
        return response.data
      })
  }

  /**
   *  자격증 등록/재발급
   *  @param Authorization {string} Authorization
   *  @param certificateBean {CertificateBean} certificateBean
   */
  upsertCertificate(params = {}) {
    return this.post(`/api/home/manager/upsertCertificate`, params)
      .then(response => {
        return response.data
      })
  }

}

export default new ManagerSvc()
